import Auth from '../common/auth/index'

export default function AuthGuard (router) {
  router.beforeEach((to, from, next) => {
    const authCode = Auth.DetectTokenInUrl()
    if (authCode !== null) {
      Auth.Login(authCode)
      return next({ name: 'HomePage', replace: true })
    }

    const token = Auth.GetToken()

    if (!token && to.meta.requiresLogin) {
      Auth.GoToSso()
      return next()
    }

    const isToRouteScoped = to.meta.scopes && to.meta.scopes.length > 0
    if (isToRouteScoped &&
        !Auth.CanManageAgainst(to.meta.scopes)) {
      next({ name: 'ForbiddenPage', replace: true })
    }

    return next()
  })
}



// WEBPACK FOOTER //
// ./src/middleware/auth-guard.js